module.exports = __webpack_public_path__ + "img/azubi_background.96605e66.jpg";